import { TFunction } from "i18next";

import { showPrivacySettings } from "@/utils/usercentrics/showPrivacySettings";

type LegalLinkWithUrl = {
  label: string;
  url: string;
};

type LegalLinkWithAction = {
  label: string;
  onClick: () => void;
};

type SidebarLegalLink = LegalLinkWithUrl | LegalLinkWithAction;

type FooterLegalLink = {
  label: string;
  link?: string;
  onClick?: () => void;
};

export const isLegalLinkWithAction = (
  link: SidebarLegalLink,
): link is LegalLinkWithAction => "onClick" in link;

export const getLegalLinksForFooter = (t: TFunction): FooterLegalLink[] => [
  {
    label: t("Footer.termsConditions.label"),
    link: t("Common.links.terms&Conditions"),
  },
  {
    label: t("Footer.dataProtection.label"),
    link: t("Common.links.privacyPolicy"),
  },
  { label: t("Footer.imprint.label"), link: t("Footer.imprint.url") },
  { label: t("Footer.disclaimer.label"), link: t("Footer.disclaimer.url") },
  { label: t("Footer.privacySettings.label"), onClick: showPrivacySettings },
];

export const getLegalLinksForSidebar = (t: TFunction): SidebarLegalLink[] => [
  { label: t("Footer.disclaimer.label"), url: t("Footer.disclaimer.url") },
  {
    label: t("Footer.termsConditions.label"),
    url: t("Common.links.terms&Conditions"),
  },
  {
    label: t("Footer.dataProtection.label"),
    url: t("Common.links.privacyPolicy"),
  },
  { label: t("Footer.imprint.label"), url: t("Footer.imprint.url") },
  { label: t("Footer.privacySettings.label"), onClick: showPrivacySettings },
];
